// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1H4qm","left":"styles_left__1kepb"};